var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-prev",class:{ 'no-count': _vm.noCount }},[_c('button',{domProps:{"innerHTML":_vm._s(_vm.$icon('prev'))},on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }